
import React, { useEffect } from 'react';
import { useAppSelector } from '@/store/hooks';
import i18n from '@/i18n';

export const I18nSyncProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const currentLang = useAppSelector((state) => state.language.currentLang);

  useEffect(() => {
    if (i18n.language !== currentLang) {
      i18n.changeLanguage(currentLang);
    }
  }, [currentLang]);

  return <>{children}</>;
}